import { useState } from 'react';
import { connect } from 'react-redux';
import { Stack, IconButton, Box, Typography, Tabs, Tab } from '@mui/material';
import { Edit } from '@mui/icons-material';
import {
  DeploymentConfigLoader,
  DeploymentModbusLoader,
  DeploymentDiscoveryLoader,
} from '../loaders/deployments';
import DeploymentMonitor from './DeploymentMonitor';
import RenameDeploymentDialog from './RenameDeploymentDialog';
import DeploymentBacnet from './DeploymentBacnet';
import DeploymentManagement from './DeploymentManagement';
import DeploymentModbus from './DeploymentModbus';
import { AUTH_LEVELS } from '../../redux/constants/roles';

const DeploymentTabs = ({ deployment, now, collectors }) => {
  const [tab, setTab] = useState(collectors.length === 0 ? 1 : 0);

  return (
    <>
      <Tabs value={tab} onChange={(event, newValue) => setTab(newValue)}>
        <Tab className="tab" label="Monitoring" />
        <Tab className="tab" label="Management" />
        <Tab className="tab" label="Bacnet" />
        <Tab className="tab" label="Modbus" />
      </Tabs>
      {tab === 0 ? <DeploymentMonitor deployment={deployment} now={now} /> : null}
      {tab === 1 ? <DeploymentManagement deployment={deployment} /> : null}
      {tab === 2 ? <DeploymentBacnet deployment={deployment} /> : null}
      {tab === 3 ? <DeploymentModbus deployment={deployment} /> : null}
    </>
  );
};

const DeploymentDetails = ({ deployment, now, canRename, collectors }) => {
  const [renameDialogOpen, setRenameDialogOpen] = useState(false);

  return (
    <Box>
      <DeploymentConfigLoader site={deployment.site} />
      <DeploymentModbusLoader site={deployment.site} />
      <DeploymentDiscoveryLoader site={deployment.site} />
      <RenameDeploymentDialog
        open={renameDialogOpen}
        close={() => setRenameDialogOpen(false)}
        deployment={deployment}
      />
      <Stack direction="row" spacing={1}>
        <Typography variant="h5">{deployment.name}</Typography>
        {canRename ? (
          <IconButton onClick={() => setRenameDialogOpen(true)} size="small">
            <Edit />
          </IconButton>
        ) : null}
      </Stack>
      {collectors !== undefined ? (
        <DeploymentTabs deployment={deployment} now={now} collectors={collectors} />
      ) : null}
    </Box>
  );
};

function mapStateToProps(state, { deployment }) {
  const {
    entities: {
      deployments: { configs },
    },
    user: { userAuthLevel },
  } = state;
  return {
    canRename: userAuthLevel <= AUTH_LEVELS.ORG_ADMIN,
    collectors: configs[deployment.site]?.collectors,
  };
}

// eslint-disable-next-line no-unused-vars
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(DeploymentDetails);
